module.exports = __webpack_public_path__ + "static/media/01-mit.e5fd996b.png";